import { render, staticRenderFns } from "./DsOriginResults.vue?vue&type=template&id=c864a128&scoped=true"
import script from "./DsOriginResults.vue?vue&type=script&lang=js"
export * from "./DsOriginResults.vue?vue&type=script&lang=js"
import style0 from "./DsOriginResults.vue?vue&type=style&index=0&id=c864a128&prod&scoped=true&lang=scss"
import style1 from "./DsOriginResults.vue?vue&type=style&index=1&id=c864a128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c864a128",
  null
  
)

export default component.exports